export default __webpack_public_path__ + "static/media/fields.05a3e8ec.jpg";